module.exports = __webpack_public_path__ + "static/media/reddit-social-media-svgrepo-com.513ff444.svg";